var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.locationFound
    ? _c(
        "div",
        { staticStyle: { height: "100%" }, on: { click: _vm.tabZoom } },
        [
          _c(
            "l-map",
            {
              ref: "locationMap",
              attrs: {
                zoom: _vm.baseZoom,
                center: _vm.center,
                options: {
                  zoomControl: false,
                  dragging: !_vm.isMobile,
                  touchZoom: !_vm.isMobile,
                  doubleClickZoom: !_vm.isMobile,
                  scrollWheelZoom: !_vm.isMobile,
                  boxZoom: !_vm.isMobile,
                  keyboard: !_vm.isMobile,
                  tap: !_vm.isMobile,
                },
              },
            },
            [
              _c("l-tile-layer", { attrs: { url: _vm.url } }),
              _c("l-marker", { attrs: { "lat-lng": _vm.center } }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }